// De voorbeelden in het zoekvenster, per propositie (testfeedback 03-11, rij 2:
// een AM van E&O zag NIS2 en post-quantum). Elke term is op 03-11 nagekeken in
// de trendlaag van die sector: hij levert trends of ontwikkelingen op, dus
// geen verzonnen tags. ICT houdt zijn oude lijst; een onbekende sector ook.

const ICT = ["NIS2", "post-quantum", "generatieve AI", "cloud", "AI Act", "krapte"];

const PER_SECTOR: Record<string, readonly string[]> = {
  ict: ICT,
  economie_ondernemen: ["klantcontact", "chatbot", "CSRD", "e-facturatie", "zzp", "webshop"],
  techniek: ["netcongestie", "robot", "waterstof", "elektrificatie", "remanufacturing", "personeelstekort"],
  veiligheid: ["boa", "drone", "crisis", "hybride dreiging", "defensie", "toezicht"],
  kinderopvang: ["gastouder", "kindcentra", "IKK", "inclusie", "zij-instroom", "personeelstekort"],
};

export function zoekVoorbeelden(sector: string | null | undefined): readonly string[] {
  return (sector && PER_SECTOR[sector]) || ICT;
}
